module.exports = __webpack_public_path__ + "static/media/Fontfabric - MullerThin.e6eeaebd.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Fontfabric - MullerThin.otf
// module id = 1072
// module chunks = 0